import { useCallback } from 'react';
import {
  buildGoogleCalendarUrl,
  buildOutlookCalendarUrl,
  type CalendarDialInOptions,
} from '../helpers/calendar';
import type { MeetingFormData } from '../types';

const useCalendarLinkGenerator = () => {
  const openOutlookEventPopup = useCallback(
    (formData: MeetingFormData, dialIn?: CalendarDialInOptions, microsoftEmail?: string | null) => {
      const url = buildOutlookCalendarUrl(formData, dialIn, microsoftEmail);
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    [],
  );

  const openGoogleEventPopup = useCallback(
    (formData: MeetingFormData, dialIn?: CalendarDialInOptions) => {
      const url = buildGoogleCalendarUrl(formData, dialIn);
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    [],
  );

  return {
    openOutlookEventPopup,
    openGoogleEventPopup,
  };
};

export default useCalendarLinkGenerator;
